import Keycloak from 'keycloak-js';

export const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL ?? 'https://auth.aldan.cloud',
  realm: import.meta.env.VITE_KEYCLOAK_REALM ?? 'cortex',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'aldan-mcp-dashboard',
});

export async function initKeycloak(): Promise<boolean> {
  return keycloak.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  });
}
